/**
 * Product Image Lightbox
 * Opens a larger view of product images when clicking on product cards
 */

class ProductLightbox {
  constructor() {
    this.lightbox = document.getElementById('product-image-lightbox');
    if (!this.lightbox) return;

    this.overlay = this.lightbox.querySelector('.lightbox__overlay');
    this.content = this.lightbox.querySelector('.lightbox__content');
    this.closeBtn = this.lightbox.querySelector('.lightbox__close');
    this.image = this.lightbox.querySelector('.lightbox__image');
    this.title = this.lightbox.querySelector('.lightbox__title');

    this.init();
  }

  init() {
    // Add click handlers to all product card images
    document.addEventListener('click', (e) => {
      // Check if click is on dietary icon - if so, prevent lightbox
      if (e.target.closest('.dietary-icon')) {
        return; // Let the tooltip work
      }

      // Check if click is on a lightbox trigger
      const trigger = e.target.closest('[data-lightbox-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        this.open(trigger);
      }
    });

    // Close lightbox handlers
    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.lightbox.style.display !== 'none') {
        this.close();
      }
    });

    // Prevent clicks on lightbox content from closing
    this.content.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // Preload images in the background after page loads
    this.preloadImages();
  }

  /**
   * Preload all lightbox images in the background
   */
  preloadImages() {
    // Wait a bit to not impact initial page load
    setTimeout(() => {
      const triggers = document.querySelectorAll('[data-lightbox-trigger]');

      triggers.forEach((trigger, index) => {
        const imageSrc = trigger.getAttribute('data-image-src');
        if (imageSrc) {
          // Stagger preloading to avoid overwhelming the browser
          setTimeout(() => {
            const img = new Image();
            img.src = imageSrc;
          }, index * 100); // 100ms delay between each image
        }
      });
    }, 1000); // Start preloading after 1 second
  }

  open(trigger) {
    const imageSrc = trigger.getAttribute('data-image-src');
    const productTitle = trigger.getAttribute('data-product-title');

    if (!imageSrc) return;

    // Set image and title
    this.image.src = imageSrc;
    this.image.alt = productTitle || 'Product image';
    this.title.textContent = productTitle || '';

    // Show lightbox
    this.lightbox.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    // Add fade-in animation
    setTimeout(() => {
      this.lightbox.classList.add('lightbox--visible');
    }, 10);
  }

  close() {
    this.lightbox.classList.remove('lightbox--visible');

    // Wait for animation before hiding
    setTimeout(() => {
      this.lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductLightbox();
  });
} else {
  new ProductLightbox();
}
